var map = {
	"./Image": [
		2601,
		9
	],
	"./Image.js": [
		2601,
		9
	],
	"./display1/item1.png": [
		6724,
		1,
		724
	],
	"./display1/item10.png": [
		2830,
		1,
		830
	],
	"./display1/item2.png": [
		1999,
		1,
		999
	],
	"./display1/item3.png": [
		8198,
		1,
		198
	],
	"./display1/item4.png": [
		8169,
		1,
		169
	],
	"./display1/item5.png": [
		3968,
		1,
		968
	],
	"./display1/item6.png": [
		1531,
		1,
		531
	],
	"./display1/item7.png": [
		9986,
		1,
		986
	],
	"./display1/item8.png": [
		9141,
		1,
		141
	],
	"./display1/item9.png": [
		7516,
		1,
		516
	],
	"./display2/item1.png": [
		9347,
		1,
		347
	],
	"./display2/item10.png": [
		8923,
		1,
		923
	],
	"./display2/item2.png": [
		2488,
		1,
		488
	],
	"./display2/item3.png": [
		2433,
		1,
		433
	],
	"./display2/item4.png": [
		6318,
		1,
		318
	],
	"./display2/item5.png": [
		7655,
		1,
		655
	],
	"./display2/item6.png": [
		9180,
		1,
		180
	],
	"./display2/item7.png": [
		2069,
		1,
		69
	],
	"./display2/item8.png": [
		66,
		1,
		66
	],
	"./display2/item9.png": [
		5419,
		1,
		419
	],
	"./icons/logo.png": [
		6928,
		1
	],
	"./icons/wesnoth-icon.png": [
		3789,
		1,
		789
	],
	"./image.css": [
		2886,
		9,
		886
	],
	"./useImage": [
		3046,
		9
	],
	"./useImage.js": [
		3046,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8388;
module.exports = webpackAsyncContext;